<style>
</style>
<template>
  <div>
    
    <fullscreen ref="fullscreen" @change="fullscreenChange" fullscreen-class="p-10 bg-white">
      <div class="w-full px-6">
          <vs-button @click="toggle" class="p-1" color="white" type="flat">
          <iconBase class="align-middle" iconName="filter_list" :width="28" :height="28" iconColor="#626262">
              <iconFullscreen v-show="!fullscreen"/>
              <iconExitfullscreen v-show="fullscreen"/>
            </iconBase>
            <span v-show="!fullscreen" class="text-grey-dark font-bold align-middle ml-2">{{$tc('Labels.Fullscreen')}}</span>
            <span v-show="fullscreen" class="text-grey-dark font-bold align-middle ml-2">{{$tc('Labels.ExitFullscreen')}}</span>
          </vs-button>
      </div>
      <div class="md:w-2/3 sm:w-full inline-block align-top">
        <div class="md:w-1/3 sm:w-full md:inline-block sm:block">
          <div class="text-xl font-bold my-2 text-center uppercase">{{$tc('Labels.TankLevel',1)}}</div>
          <div class="block py-1 px-6">
            <statistics
              class="hover:bg-success cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(tankPercent,0)"
              :statisticTitle="'100% '+ $t('Labels.To') +' 50%'"
              bgColor="success-75"
              txtColor="white"
              url="/gas?begin_percent=50&end_percent=100"
            />
          </div>
        
          <div class="block py-1 px-6">
            <statistics
              class="hover:bg-warning cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(tankPercent,1)"
              :statisticTitle="'49% '+ $t('Labels.To') +' 20%'"
              bgColor="warning-75"
              txtColor="white"
              url="/gas?begin_percent=20&end_percent=49"
            />
          </div>
          <div class="block py-1 px-6">
            <statistics
              class="hover:bg-danger cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(tankPercent,2)"
              :statisticTitle="'19% '+ $t('Labels.To') +' 0%'"
              bgColor="danger-75"
              txtColor="white"
              url="/gas?begin_percent=0&end_percent=19"
            />
          </div>
        </div>
        <div class="md:w-1/3 sm:w-full md:inline-block sm:block">
          <div class="text-xl font-bold my-2 text-center uppercase">{{$t('Labels.LastSeen')}}</div>
          <div class="block py-1 px-6">
            <statistics
              class="hover:bg-success cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(lastSeen,0)"
              :statisticTitle="'0 '+ $t('Labels.To') +' 4 '+ $t('Labels.Hours')"
              bgColor="success-75"
              txtColor="white"
              url="/gas?begin_last_seen=0&end_last_seen=4"
            />
          </div>
          <div class="block py-1 px-6">
          <statistics
              class="hover:bg-warning cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(lastSeen,1)"
              :statisticTitle="'4 '+ $t('Labels.To') +' 8 '+ $t('Labels.Hours')"
              bgColor="warning-75"
              txtColor="white"
              url="/gas?begin_last_seen=4&end_last_seen=8"
            />
          </div>
          <div class="block py-1 px-6">
          <statistics
              class="hover:bg-danger cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(lastSeen,2)"
              :statisticTitle="'8+ '+$t('Labels.Hours')"
              bgColor="danger-75"
              txtColor="white"
              url="/gas?begin_last_seen=8&end_last_seen=0"
            />
          </div>
        </div>
        <div class="md:w-1/3 sm:w-full md:inline-block sm:block">
          <div class="text-xl font-bold my-2 text-center uppercase">{{$t('Labels.BatteryLevel')}}</div>
          <div class="block py-1 px-6">
            <statistics
              class="hover:bg-success cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(battery,0)"
              :statisticTitle="'100% '+ $t('Labels.To') +' 50%'"
              bgColor="success-75"
              txtColor="white"
              url="/gas?begin_battery=50&end_battery=100"
            />
          </div>
          <div class="block py-1 px-6">
            <statistics
              class="hover:bg-warning cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(battery,1)"
              :statisticTitle="'49% '+ $t('Labels.To') +' 20%'"
              bgColor="warning-75"
              txtColor="white"
              url="/gas?begin_battery=20&end_battery=49"
            />
          </div>
          <div class="block py-1 px-6">
            <statistics
              class="hover:bg-danger cursor-pointer"
              v-show="isReady"
              :statistic="getObjIndex(battery,2)"
              :statisticTitle="'19% '+ $t('Labels.To') +' 0%'"
              bgColor="danger-75"
              txtColor="white"
              url="/gas?begin_battery=0&end_battery=19"
            />
          </div>
        </div>
      </div>
      <div class="md:w-1/3 sm:w-full sm:text-center inline-block align-top">
        <div class="text-xl font-bold my-2 text-center uppercase">{{$t('Labels.Gauges')}}</div>
        <div class="block py-1 px-6">
          <statistics
            class="hover:bg-grey cursor-pointer"
            :statistic="gaugesTotal"
            :statisticTitle="$t('Labels.Total')"
            bgColor="white"
            txtColor="gray-800"
            url="/gas"
          />
        </div>
        <div class="block p-1">
          <vue-apex-charts v-if="isReady" type="donut" height="160" :options="stateChart.chartOptions" :series="stateChart.series"></vue-apex-charts>
        </div>
      </div>
      <div class="text-xl font-bold mt-8 mb-2 text-center uppercase">{{$t('Labels.ApproximateLitersSpent')}}</div>
      <div class="md:w-1/2 sm:w-full  inline-block px-2">
        <vue-apex-charts v-if="chartConsume" type="line" height="300" :options="consumeChart.chartOptions" :series="consumeChart.series"></vue-apex-charts> 
      </div>
      <div class="md:w-1/2 sm:w-full inline-block px-2">
        <vue-apex-charts v-if="chartWeek" type="line" height="300" :options="consumeWeek.chartOptions" :series="consumeWeek.series"></vue-apex-charts>
      </div>
    </fullscreen>
  </div>
</template>
<script>
import statistics from '@/components/statistics/statistics.vue'
import VueApexCharts from 'vue-apexcharts'
import {request} from '@/request.js'
import iconBase from '@/components/icons/iconBase'
import iconFullscreen from '@/components/icons/iconFullscreen'
import iconExitfullscreen from '@/components/icons/iconExitfullscreen'
//import ApexCharts from 'apexcharts'

export default {
  components: {
    statistics,
    VueApexCharts,
    iconBase,
    iconFullscreen,
    iconExitfullscreen
  },
  data () {
    return {
      stateChart: {
        series: [75, 25],
        chartOptions: {
          labels: [this.$t('Labels.Actives'), this.$t('Labels.Inactives')],
          colors: ['#4dc770', '#ea5455'],
          chart: {
            id: 'chart-state',
            width: 200,
            events: {
              legendClick (chartContext, seriesIndex) {
                if (seriesIndex === 0) window.location.href = '/gas?status_device=active'
                else window.location.href = '/gas?status_device=inactive'
              },
              dataPointSelection (event, chartContext, config) {
                if (config.dataPointIndex === 0) window.location.href = '/gas?status_device=active'
                else window.location.href = '/gas?status_device=inactive'
              }
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      },
      alertChart: {
        series: [75, 25],
        chartOptions: {
          labels: [this.$t('Labels.InstallationOK'), this.$t('Labels.InstallationAlert')],
          colors: ['#34c4c3', '#fd9f43'],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 300
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      },
      /*consumeChart: {
        series: [
          {
            name: this.$t('Labels.Liters'),
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#00C3C3'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: [],
            title: {
              text: this.$t('Labels.Date'),
            }
          },
          yaxis: {
            title: {
              text: this.$t('Labels.Liters'),
            }
          },
          annotations: {
            yaxis: [{
                y: 10,
                borderColor: '#ea5455',
                label: {
                  borderColor: '#fff',
                  style: {
                    color: '#2c2c2c',
                    background: '#fff',
                  },
                  text: this.$t('Labels.Minimum'),
                }
              },
              {
                y: 100,
                borderColor: '#ea5455',
                label: {
                  borderColor: '#fff',
                  style: {
                    color: '#2c2c2c',
                    background: '#fff',
                  },
                  text: this.$t('Labels.Maximum'),
                }
              },
              {
                y: 25,
                borderColor: '#3577f0',
                label: {
                  borderColor: '#fff',
                  style: {
                    color: '#2c2c2c',
                    background: '#fff',
                  },
                  text: this.$t('Labels.Average'),
                }
              }
            ]
          }
        }
      },*/
      consumeChart: {
        series: [
          {
            name: this.$t('Labels.Current'),
            data: []
          },
          {
            name: this.$t('Labels.Previous'),
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#00C3C3', '#2196f3'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text:  `${this.$t('Labels.DailySpend')  } ${  this.$t('Labels.Approximate')}`,
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: []
          }
        }
      },
      consumeWeek: {
        series: [
          {
            name: this.$t('Labels.Current'),
            data: []
          },
          {
            name: this.$t('Labels.Previous'),
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: ['#00C3C3', '#2196f3'],
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text:  `${this.$t('Labels.WeeklySpend')  } ${  this.$t('Labels.Approximate')}`,
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          xaxis: {
            categories: [
              this.$t('Labels.Sunday'),
              this.$t('Labels.Monday'),
              this.$t('Labels.Tuesday'),
              this.$t('Labels.Wednesday'),
              this.$t('Labels.Thursday'),
              this.$t('Labels.Friday'),
              this.$t('Labels.Saturday')
            ]
          }
        }
      },
      todayChart:{
        series: [55],
        chartOptions: {
          colors: ['#00C3C3'],
          chart: {
            height: 350,
            type: 'radialBar'
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '50%'
              }
            }
          },
          labels: [this.$t('Labels.Today')]
        }
      },
      weekChart:{
        series: [75],
        chartOptions: {
          colors: ['#45bb4c'],
          chart: {
            height: 350,
            type: 'radialBar'
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '50%'
              }
            }
          },
          labels: [this.$t('Labels.Week')]
        }
      },
      monthChart:{
        series: [85],
        chartOptions: {
          colors: ['#3577f0'],
          chart: {
            height: 350,
            type: 'radialBar'
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: '50%'
              }
            }
          },
          labels: [this.$t('Labels.Month')]
        }
      },
      tankPercent: [0, 0, 0],
      battery: [0, 0, 0],
      lastSeen: [0, 0, 0],
      isReady: false,
      gaugesTotal: 0,
      fullscreen: false,
      chartConsume: false,
      chartWeek: false
    }
  },
  methods: {
    async getResponse () {
      this.$vs.loading()
      const params = {
        url: 'gas_devices/dashboard',
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.tankPercent[2] = parseInt(response.data.data.percent['0-19'])
        this.tankPercent[1] = parseInt(response.data.data.percent['49-20'])
        this.tankPercent[0] = parseInt(response.data.data.percent['100-50'])

        this.battery[2] = parseInt(response.data.data.battery['0-19'])
        this.battery[1] = parseInt(response.data.data.battery['49-20'])
        this.battery[0] = parseInt(response.data.data.battery['100-50'])

        this.lastSeen[2] = parseInt(response.data.data.last_seen['8'])
        this.lastSeen[1] = parseInt(response.data.data.last_seen['4-8'])
        this.lastSeen[0] = parseInt(response.data.data.last_seen['0-4'])

        this.gaugesTotal = parseInt(response.data.data.meters['total'])
        this.stateChart.series[0] = parseInt(response.data.data.meters['active'])
        this.stateChart.series[1] = parseInt(response.data.data.meters['inactive'])
        this.alertChart.series[0] = parseInt(response.data.data.meters['good_install'])
        this.alertChart.series[1] = parseInt(response.data.data.meters['bad_install'])

        this.todayChart.series[0] = parseInt(response.data.data.consume['last_day'])
        this.weekChart.series[0] = parseInt(response.data.data.consume['last_week'])
        this.monthChart.series[0] = parseInt(response.data.data.consume['last_month'])

        /*for (let index = 0; index < response.data.data.consume["consume_last_week"].length - 1; index++) {
          this.consumeChart.series[0].data[index] = response.data.data.consume["consume_last_week"][index]["consumo"]
          this.consumeChart.chartOptions.xaxis.categories.push(response.data.data.consume["consume_last_week"][index]["days"])
        }

        this.consumeChart.chartOptions.annotations.yaxis[0].y = response.data.data.consume["annotations"]["min"]
        this.consumeChart.chartOptions.annotations.yaxis[1].y = response.data.data.consume["annotations"]["max"]
        this.consumeChart.chartOptions.annotations.yaxis[2].y = response.data.data.consume["annotations"]["avg"]*/
      }).finally(() => {
        this.$vs.loading.close()
        this.isReady = true
      })
      
    },
    getObjIndex (obj, index) {
      return obj[index]
    },
    toggle () {
      this.$refs['fullscreen'].toggle() // recommended
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    async getConsume () {
      const params = {
        url: 'gas_devices/consume_by_day',
        method: 'GET'
      }
      await request(params).then(response => {
        let index = 0
        for (const key in response.data.data) {
          if (Object.hasOwnProperty.call(response.data.data, key)) {
            const element = response.data.data[key]
            if (index < 2) element.forEach(item => {
              this.consumeChart.series[index].data.push(parseFloat(item.consumodia) * -1)
              if (index === 0) this.consumeChart.chartOptions.xaxis.categories.push(item.hours)
            })
          }
          index++
        }
        
      }).finally(() => {
        this.chartConsume = true
      })
    },
    async getConsumeWeek () {
      const params = {
        url: 'gas_devices/consume_by_week',
        method: 'GET'
      }
      await request(params).then(response => {
        let index = 1
        for (const key in response.data.data) {
          if (Object.hasOwnProperty.call(response.data.data, key)) {
            const element = response.data.data[key]    
            element.forEach(item => {
              this.consumeWeek.series[index].data.push(parseFloat(item.consumodia) * -1)
            })
          }
          index--
        }
        this.chartWeek = true
      })
    }
  },
  created () {
    this.getResponse()
    this.getConsume()
    this.getConsumeWeek()
  }
}
</script>